module.exports = __webpack_public_path__ + "img/thumb_05.6cb2549b.jpg";